import React from "react";

const GreetingsSelect = (props) => {
	return (
		<select {...props} disabled={props.disabled}>
			<option value="" defaultValue>-- Saludo --</option>
			<option value="Sr">Señor</option>
			<option value="Sra">Señora</option>
			<option value="Srita">Señorita</option>
			<option value="Lic">Licenciado</option>
			<option value="Licda">Licenciada</option>
			<option value="Ing">Ingeniero</option>
			<option value="Ingra">Ingeniera</option>
			<option value="Dr">Doctor</option>
			<option value="Dra">Doctora</option>
			<option value="Mtro">Maestro</option>
			<option value="Mtra">Maestra</option>
		</select>
	)
}

export default GreetingsSelect;


// WEBPACK FOOTER //
// ./src/elements/forms/greeting_select.jsx